module.exports = __webpack_public_path__ + "static/media/E_WHITOUT_B_White.52cb466c.jpg";